<div class="form-div">
  <form class="login-form" id="basicInfoForm" [formGroup]="signUpForm" (ngSubmit)="signUpFormSubmitted()">
    <h2 i18n>Your Account Details</h2>
    <p class="mb-3" i18n>Please fill the following form to create an account.</p>

    <div class="form-floating mb-3">
      <input type="text" class="form-control" id="name" formControlName="name" placeholder="Your Name"
             [ngClass]="{'is-invalid': (name?.touched && name?.invalid) || customerSignupService.nameErrorMessage !== null}">
      <label for="name" i18n>Your Name</label>
      <div class="invalid-feedback" *ngIf="name?.touched && name?.invalid">
        <div *ngIf="name?.hasError('required')" i18n>Name is required.</div>
        <div *ngIf="name?.hasError('maxlength')" i18n>Name too long.</div>
      </div>
      <div class="invalid-feedback"
           *ngIf="customerSignupService.nameErrorMessage !== null">{{ customerSignupService.nameErrorMessage }}
      </div>
    </div>

    <div class="form-floating mb-3">
      <mobile-number
        mobileNumberId="mobile"
        countryCodeId="countryCodeId"
        [validators]="[Validators.required]"
        [list]="countries"
        [floatingMobileLabel]="mobile"
        [floatingCodeLabel]="code"
        [group]="signUpForm">
      </mobile-number>
    </div>

    <div class="form-floating mb-3">
      <input type="email" class="form-control" id="floatingInputEmail" formControlName="email"
             placeholder="Email Address"
             [ngClass]="{'is-invalid': (email?.touched && email?.invalid) || customerSignupService.emailErrorMessage !== null}">
      <label for="floatingInputEmail" i18n>Email Address</label>
      <div class="invalid-feedback" *ngIf="email?.touched && email?.invalid">
        <div *ngIf="email?.hasError('required')" i18n>Email is required.</div>
        <div *ngIf="email?.hasError('email')" i18n>Incorrect email format.</div>
      </div>
      <div class="invalid-feedback"
           *ngIf="customerSignupService.emailErrorMessage !== null">{{ customerSignupService.emailErrorMessage }}
      </div>
    </div>

    <div class="form-floating mb-3 password-div">
      <input [type]="showPasswordFieldText ? 'text' : 'password'" class="form-control password-field"
             id="floatingInputPassword" formControlName="password" placeholder="Password"
             [ngClass]="{'is-invalid': (password?.touched && password?.invalid) || customerSignupService.passwordErrorMessage !== null}">
      <label for="floatingInputPassword" i18n>Password</label>
      <i class="bi bi-eye-fill password-show-icon" (click)="togglePasswordShowButtonClicked()"></i>
      <div class="invalid-feedback" *ngIf="password?.touched && password?.invalid">
        <div *ngIf="password?.hasError('required')" i18n>Password is required.</div>
        <div *ngIf="password?.hasError('minlength')" i18n>Password must be more than 8 characters.</div>
        <div *ngIf="password?.hasError('maxlength')" i18n>Password too long.</div>
        <div *ngIf="password?.hasError('passwordStrength')" i18n="@@passwordStrengthError">Password must contain at least one uppercase letter,
          one lowercase letter, a number and one special character.
        </div>
      </div>
      <div class="invalid-feedback"
           *ngIf="customerSignupService.passwordErrorMessage !== null">{{ customerSignupService.passwordErrorMessage }}
      </div>
    </div>

    <div class="form-check">
      <input class="form-check-input" type="checkbox" formControlName="agreeToTerms" id="agreeToTerms"
             [ngClass]="{'is-invalid': (agreeToTerms?.touched && agreeToTerms?.invalid)}"/>
      <label class="form-check-label" for="agreeToTerms" i18n="@@agreeToTerms">I agree to the <a class="text-muted"
                                                                                                 routerLink="/terms-and-conditions"
                                                                                                 routerLinkActive="active"
                                                                                                 ariaCurrentWhenActive="page">Terms
        and Conditions</a>.</label>
      <div *ngIf="(agreeToTerms?.touched && agreeToTerms?.hasError('required'))" class="invalid-feedback"
           i18n="@@agreeToTermsError">You must agree to the Terms and Conditions to proceed.
      </div>
    </div>


    <div class="alert alert-danger form-alert"
         *ngIf="customerSignupService.signUpFormErrorMessage !== null">{{ customerSignupService.signUpFormErrorMessage }}
    </div>

  </form>
</div>
